import React from "react"

export default function Blog028() {
  return (
    <section>
    <article>
    <h2>28. 12-16-2022</h2>
          <h3>New Website</h3>
          <p>
          <strong>Hello!</strong>
          <br /><br />
          Hello and welcome to my website! I'm excited to announce that I recently updated my website, ericpolley.com, with the help of React.js and tailwind. For those unfamiliar with these technologies, React.js is a JavaScript library that is commonly used for building user interfaces, and tailwind is a CSS framework that provides a set of utility classes for quickly styling elements.
<br /><br />
To implement these updates, I also utilized react-router-dom, which is a library that helps with managing routes within a React application. I created a header component to provide consistent navigation throughout the site, and deployed the updates using netlify, a platform that makes it easy to host static websites.
<br /><br />
To document the process of updating my website, I recorded a seven-part video series that will be available on my website soon. In these videos, I go through each step of the update process, from setting up the development environment to deploying the finished product.
<br /><br />
In addition to this video series, I have recorded a bunch of tutorial videos that are available now on my YouTube channel. These videos cover a wide range of topics, from basic programming concepts to more advanced techniques. If you're interested in learning more about web development, be sure to check out my channel and watch some of my videos.
<br /><br />
Thanks for reading, and I hope you enjoy exploring my updated website!
<br /><br />
Best regards,
Eric Polley


         
          </p>
          
          </article>

        <h4>Links</h4>
        <br />
        <ul>
        
          <li>
            <a
              href="http://ericpolley.com"
              title="Check out my Portfolio!"
              target="_blank"
              rel="noopener noreferrer" 
            >
              <strong><p>Eric Polley's Website</p></strong></a
            >
          </li>
        </ul>
        </ section >
  )
}
